import * as config from "./assets/config.json";
import {
  captchaEndpoint,
  baseUrl,
  refreshTokenUrl,
  logoutUrl,
  production,
  realm_url,
  client_id,
  enableCaptcha,
  paymentVersion
} from "./assets/config.json";

import { ViewEncapsulation, enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from "./environments/environment";

// const config = require('./assets/config.json');
// environment.api = config["baseUrl"];
// environment.code = config["code"];

const initStyles = function () {
  return new Promise((resolve, reject) => {
    let styles = ['css/rtl/style.css', 'css/rtl/renew.css'], querystring = '', p = /(renew.css)|(style.css)/g;

    styles.forEach(stylePath => {

      let brandingBaseURL = document.createElement('link');
      brandingBaseURL.setAttribute("href", './assets/css/rtl/style.css');
      brandingBaseURL.setAttribute("rel", "stylesheet");

      // brandingBaseURL.setAttribute("id", stylePath.match(p)[0]);
      const matches = stylePath.match(p);
      if (matches && matches.length > 0) {
        brandingBaseURL.setAttribute("id", matches[0]);
      }

      document.head.appendChild(brandingBaseURL);
    });

    if (
      document.getElementById('style.css') &&
      document.getElementById('renew.css')
    ) {
      return resolve(true);
    }
  });
}

// Enable production mode unless running locally
if (!/localhost/.test(document.location.host)) {
  enableProdMode();
}

// const prod = require('./assets/config.json').production;
const prod = environment.production;
// const prod = config.production;
// const prod = production;
if (prod) {
  //alert(prod)
  enableProdMode();
}

initStyles().then(res => {
  if (res) {
    setTimeout(() => {
      platformBrowserDynamic().bootstrapModule(AppModule, {
        defaultEncapsulation: ViewEncapsulation.None
      });
    }, 300);
  }
});
